// Bump this on each frontend release. The server compares heartbeat payloads against
// the required release id in Firestore controls/{environment}. If they differ, the
// app shows a reload prompt.
export const APP_RELEASE_ID = "2026-10-11.1";
